import React from 'react'
import { store } from '../../../store'
import Rolling from '../../../Images/rolling.svg'
import html2canvas from 'html2canvas'
import {Helmet} from 'react-helmet'

const WebsiteSettings = ({toHTML, htmlpage, onImages, onLinks, onCustomization, onAboutContent, onAboutContentRaw,onWebsiteName, onWebsiteBio, onWebsiteUrl, onTemplate, onRouteChange, toMake, websiteStatus, onWebsiteStatus, onOpen}) => {
let websitedetails = null
websitedetails = store.getState().website.sites.map((value,i) => 
{
	const getWebsiteData = (value, check) => {
	if(check !== 'changetheme') {
		onWebsiteStatus('processing')
	}
	else {
		onWebsiteStatus('processingtheme')
	}
	onWebsiteName(value.name)
	onWebsiteUrl(value.url)
	onWebsiteBio(value.bio)
	onTemplate(value.template)
	fetch(`${process.env.REACT_APP_API}/web`, {
		method: 'post',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({
		url: store.getState().website.url
		})
	})
	.then((response)=> response.json())
	.then((data)=>
	{
			if(data)
			{
				onCustomization(data.customization)
				onImages(data.image)
				onLinks(data.links)
				onAboutContent(data.about[0].content)
				onAboutContentRaw(data.about[0].rawcontent)
				if(check === 'changetheme')
				{
					onOpen('changetheme')
					onWebsiteStatus('')
				}
				else
				{
					setTimeout(
			    	function() {
					onRouteChange(value.template)
					toMake(true)
			    	}
			    	.bind(this),
			    	500
					)
				}
			}
		})	
	}
	const BGcover = () => {
		if(`${process.env.REACT_APP_API}/uploads/${value.url}/cover.jpg`) {
			return `${process.env.REACT_APP_API}/uploads/${value.url}/cover.jpg`
		}
		else {
			return null
		}
	}
		return(
		<div className="settings_inside">
        <Helmet>
        <script async defer src="https://platform.twitter.com/widgets.js"></script>
        <script async defer src="https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v3.2"></script>
        </Helmet>
		<h3>Profile Pages</h3>
		<div className="settings_inside_content">
        <div className="dash_website_bg"
			style={{
				"backgroundImage": `url(${BGcover()})`
			}} >
		<div className="dash_websites_in">
		<div className="dash_websites">
		<div className="dash_name">
		<a target="_blank" href={`${process.env.REACT_APP_API}/${value.url}`} rel="noopener noreferrer">{value.name}</a>
		</div>
        <div className="share_btn">
			<a class="twitter-share-button"
			  href={`https://twitter.com/intent/tweet?text=Check%20out%20my%20vieww profile%3A%0Ahttps%3A%2F%2F${value.url}%2Evieww%2Eme`}
			  data-url={`https%3A%2F%2F${value.url}%2Evieww%2Eme`}
			  data-size="small"
			  target="_blank">
			Tweet</a>
		</div>
		<div>
        <span className="changetheme_settings" onClick={getWebsiteData.bind(this, value, 'changetheme')}>
        {websiteStatus === 'processingtheme'
          ?	<span className="rolling"><img src={Rolling} className="rolling_img_theme" alt="rolling"/></span>
          : <i className="fa fa-cog changetheme" name="change theme"></i>
      		}
        Change Theme</span>
		<button className="top_btn dash_btn" onClick={getWebsiteData.bind(this, value)}>
        {websiteStatus === 'processing'
          ?<span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
          : null
      		}
      	{!websiteStatus || websiteStatus === 'processingtheme'
          ?<span>Edit</span>
          : null
      		}
          </button>
          </div>
		</div>
		</div>
		</div>
		</div>
		</div>
		)
	})
	return websitedetails
}

export default WebsiteSettings